import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'ui-header',
  template: `
    <div
      class="flex justify-between items-center py-2 bg-white border-b border-b-[#E8EAED] h-10"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class HeaderComponent {}
